<template>
  <div>
    <navigation-label
      :label="($attrs.label ? $attrs.label : displayAsSingular)"
      :displayAsSingular="displayAsSingular"
      :displayAsPlural="displayAsPlural"
      :tooltip="`${displayAsSingular} Maintenance`"
      routeTo="../categories"
    />

    <v-container
      class="pa-0 ma-0"
    >
      <v-row
        no-gutters
      >
        <v-col
          cols="12"
          sm="12"
          md="11"
        >
          <v-combobox
            :id="`key-category-${$attrs.id}`"
            v-model="internalValue"
            :items="categories.data"
            item-text="description"
            item-value="id"
            autofocus
            outlined
            dense
            clearable
            class="ml-1 mt-0 mb-0"
            :hint="`Select a ${displayAsSingular} ${$attrs.appendhint}`"
            :loading="categories.isBusy"
            :rules="[appRules.validOption(internalValue, categories.data, `${displayAsSingular} does not exist in the list.`)]"
            @change="onChange"
          />
        </v-col>

        <v-col
          cols="12"
          sm="1"
          :class="colClass"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                x-small
                color="primary"
                v-bind="attrs"
                :disabled="disablePrevious"
                v-on="on"
                @click="previous_onClick"
              >
                <v-icon>mdi-skip-previous-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Previous {{ displayAsSingular }}</span>
          </v-tooltip>

          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                x-small
                color="primary"
                v-bind="attrs"
                :disabled="disableNext"
                v-on="on"
                @click="next_onClick"
              >
                <v-icon>mdi-skip-next-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Next {{ displayAsSingular }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { get } from 'vuex-pathify'
  import NavigationLabel from '@/components/maintenance/controls/NavigationLabel'

  export default {
    name: 'SelectCategory',

    components: {
      NavigationLabel,
    },

    props: {
      value: {
        type: Object,
        default: null,
      },
    },

    data () {
      return {
        internalValue: this.value,
      }
    },

    computed: {
      appRules: get('app/rules'),
      categories: get('category/categories'),
      displayAsSingular: get('category/displayAsSingular'),
      displayAsPlural: get('category/displayAsPlural'),
      colClass () {
        let newClass = 'text-no-wrap d-inline'
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          case 'sm':
            newClass = 'd-none'
            break
        }
        return newClass
      },
      disablePrevious () {
        let disabledButton = true

        if (disabledButton && this.categories.data) {
          if (this.categories.data.length > 0) {
            disabledButton = this.categories.isFirst
          }
        }

        return disabledButton
      },
      disableNext () {
        let disabledButton = true

        if (disabledButton && this.categories.data) {
          if (this.categories.data.length > 0) {
            disabledButton = this.categories.isLast
          }
        }

        return disabledButton
      },
    },

    watch: {
      internalValue: {
        handler (val, oldVal) {
          if (val && {}.hasOwnProperty.call(val, 'id')) {
            if (oldVal &&
              val.id === oldVal.id &&
              val.description === oldVal.description) return

            this.$emit('input', this.internalValue)
          }
        },
      },
      value: {
        handler (val, oldVal) {
          if (val && {}.hasOwnProperty.call(val, 'id')) {
            if (oldVal &&
              val.id === oldVal.id &&
              val.description === oldVal.description) return

            this.internalValue = val
          }
        },
      },
    },

    created () {
      this.$store.dispatch('category/retrieveAll')
    },

    mounted () {
      this.initialize()
    },

    methods: {
      setSelected (selectedItem) {
        this.$store.dispatch('category/setSelected', selectedItem)
      },

      initialize () {
        let setDefault = true

        if (this.categories.selectedItem && {}.hasOwnProperty.call(this.categories.selectedItem, 'id')) {
          if (this.categories.selectedItem.id.length > 0) {
            setDefault = false
          }
        }

        if (setDefault && this.categories.data.length > 0) {
          this.setSelected(this.categories.data[0])
        }
      },

      onChange (selectedItem) {
        this.setSelected(selectedItem)

        this.$emit('change', selectedItem)
      },

      previous_onClick () {
        this.$store.dispatch('category/previous')
      },

      next_onClick () {
        this.$store.dispatch('category/next')
      },
    },
  }
</script>

<style scoped>

</style>
